// Print the current page light-themed regardless of the on-screen theme.
// The print stylesheet in index.css hides app chrome; "export to PDF" is the
// browser's Print → Save as PDF.
export function printPage() {
  const root = document.documentElement;
  const wasDark = root.classList.contains('dark');
  if (wasDark) root.classList.remove('dark');
  let restored = false;
  const restore = () => {
    if (restored) return;
    restored = true;
    if (wasDark) root.classList.add('dark');
    window.removeEventListener('afterprint', restore);
  };
  window.addEventListener('afterprint', restore);
  window.print();
  // Some browsers return from print() before afterprint fires; this is a
  // safety net (restore is idempotent).
  setTimeout(restore, 1000);
}
